'use client'

import { useEffect, useRef } from 'react'

import { TRoomEvent } from '@/entities/room'
import { useAirbridgeContext } from '@/shared/config'

type Props = {
  airbridgeEvent: TRoomEvent
}

export const AirbridgeEventSender = ({ airbridgeEvent }: Props) => {
  const { sendEvent, isInitialized } = useAirbridgeContext()
  const sentIdsRef = useRef<Set<number>>(new Set())

  useEffect(() => {
    // initialized 되지 않았거나 strict mode 중복인 경우 return
    if (!isInitialized || sentIdsRef.current.has(airbridgeEvent.productId)) {
      return
    }

    sentIdsRef.current.add(airbridgeEvent.productId)

    const params = {
      action: airbridgeEvent.action,
      label: airbridgeEvent.label,
      value: airbridgeEvent.value,
      semanticAttributes: {
        currency: 'KRW',
        products: [
          {
            productID: airbridgeEvent.productId,
            name: airbridgeEvent.productName,
            categoryName: airbridgeEvent.categoryName,
            price: airbridgeEvent.price,
            position: 1,
            currency: 'KRW',
          },
        ],
      },
    }

    sendEvent({
      event: airbridgeEvent.eventName,
      params,
    })
  }, [airbridgeEvent, isInitialized, sendEvent])

  return null
}
